<template>
    <div class="SwitchConexion">
        <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch" :checked="esModoSinConexion"
                id="switchConexion" @click="cambiarModo" />
            <label class="form-check-label" for="switchConexion">Sin Conexión</label>
        </div>
    </div>
</template>

<script>
import localforage from "localforage";
import Swal from "sweetalert2";
export default {
    name: "SwitchConexion",

    data() {
        return {
            esModoSinConexion: false
        }
    },

    async mounted() {
        const modoSinConexion = await localforage.getItem(this.$store.state.colecciones.localforage.modoSinConexion);
        this.esModoSinConexion = modoSinConexion ? modoSinConexion : false;
    },

    methods: {
        seleccionarSwitch() {
            document.getElementById("switchConexion").click();
        },

        async cambiarModo(event) {
            if (event.target.checked && !this.esModoSinConexion) {
                Swal.fire({
                    icon: "info",
                    background: 'rgba(255, 255, 255)',
                    backdrop: `rgba(0,0,0,0.7)`,
                    title: `<h6 class='text-dark'>¿Está seguro que desea activar el modo sin conexión?</h6>`,
                    html: `
                        <p class='text-dark text-start'>
                            <b style='font-size: 13pt !important' class='text-decoration-underline'>
                                Al activar este modo, se descargará información necesaria únicamente para consulta.
                            </b> 
                            <br /><br />

                            Ten en cuenta que algunas funciones pueden estar limitadas y que los datos descargados 
                            estarán disponibles solo localmente.
                            <br /><br />

                            <b style='font-size: 13pt !important' class='text-danger text-decoration-underline'>
                                Te recomendamos proceder con precaución.
                            </b>
                        </p>
                    `,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: "Activar",
                    cancelButtonText: "Cancelar",
                    reverseButtons: false,
                    customClass: {
                        confirmButton: "btn btn-primary btn-md fw-bold me-2 mb-3",
                        cancelButton: "btn btn-secondary btn-md fw-bold mb-3",
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                }).then(async (result) => {
                    document.getElementById('switchConexion').checked = result.isConfirmed ? true : false;
                    if (result.isConfirmed) {
                        this.$isLoading(true);
                        await this.$store.state.descargarInformacionOffline(true);
                        await localforage.setItem(this.$store.state.colecciones.localforage.modoSinConexion, true);
                        this.$isLoading(false);
                        this.$router.go(0);
                    }
                });
            } else if (!event.target.checked && this.esModoSinConexion) {
                const inspecciones = await localforage.getItem(this.$store.state.colecciones.localforage.seguridadVial.inspecciones.registros);
                const aptitudesFisicas = await localforage.getItem(this.$store.state.colecciones.localforage.seguridadVial.aptitudes.registros);
                const planesDesplazamientos = await localforage.getItem(this.$store.state.colecciones.localforage.seguridadVial.planesDesplazamientos.registros);
                const modulos = [
                    {
                        modulo: "Inspecciones",
                        registros: inspecciones ? inspecciones : [],
                    },
                    {
                        modulo: "Aptitudes Físicas",
                        registros: aptitudesFisicas ? aptitudesFisicas : [],
                    },
                    {
                        modulo: "Planes de Desplazamientos",
                        registros: planesDesplazamientos ? planesDesplazamientos : [],
                    }
                ]
                const porSincronizar = modulos.filter(item => item.registros.length > 0);
                if (porSincronizar.length > 0) {
                    Swal.fire({
                        icon: "info",
                        background: 'rgba(255, 255, 255)',
                        backdrop: `rgba(0,0,0,0.7)`,
                        html: `
                            <p class="text-dark text-start">
                                <b style="font-size: 13pt !important" class="text-decoration-underline text-danger">
                                    Los datos registrados durante este modo deben ser sincronizados antes de desactivarlo.
                                </b>
                                <br /><br />

                                Aún te falta por sincronizar los siguientes módulos:
                               
                                <ul class='text-start' style="font-size: 13pt !important; margin-left: -15px !important">
                                    ${porSincronizar.filter(item => item.registros.length > 0).map(item => `<li class='fw-semibold'>${item.modulo}.</li>`).join('')}
                                </ul>
                            </p>
                        `,
                        buttonsStyling: false,
                        confirmButtonText: "Entendido",
                        reverseButtons: false,
                        customClass: {
                            confirmButton: "btn btn-primary btn-md fw-bold",
                        },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(async () => {
                        document.getElementById('switchConexion').checked = true;
                    });
                } else {
                    Swal.fire({
                        icon: "info",
                        background: 'rgba(255, 255, 255)',
                        backdrop: `rgba(0,0,0,0.7)`,
                        title: `<h6 class='text-dark'>¿Está seguro que desea desactivar el modo sin conexión?</h6>`,
                        html: `
                            <p class="text-dark text-start">
                                <b style="font-size: 13pt !important" class="text-decoration-underline">
                                    Al desactivar el modo sin conexión, se limpiará la información usada para consulta localmente.
                                </b>
                                <br /><br />

                                Los datos registrados durante este modo ya fueron sincronizados y se encuentran disponibles en
                                su respectivo espacio de trabajo.
                            </p>
                        `,
                        buttonsStyling: false,
                        showCancelButton: true,
                        confirmButtonText: "Desactivar",
                        cancelButtonText: "Cancelar",
                        reverseButtons: false,
                        customClass: {
                            confirmButton: "btn btn-primary btn-md fw-bold me-2 mb-3",
                            cancelButton: "btn btn-secondary btn-md fw-bold mb-3",
                        },
                        allowOutsideClick: false,
                        allowEscapeKey: false,

                    }).then(async (result) => {
                        document.getElementById('switchConexion').checked = result.isConfirmed ? false : true;
                        if (result.isConfirmed) {
                            this.$isLoading(true);
                            await this.$store.state.descargarInformacionOffline(false);
                            await localforage.setItem(this.$store.state.colecciones.localforage.modoSinConexion, false);
                            this.$isLoading(false);
                            this.$router.go(0);
                        }
                    });
                }
            }
        }
    }
}
</script>

<style scoped>
.form-check {
    margin-left: -5px;
}
</style>